import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDiaryVenue } from 'shared-types/index';
import { useSelector } from 'react-redux';
import store, { AppDispatch } from 'appRoot/Store';
import {IVenueState} from "./types";
import {DiaryRootState} from "appRoot/rootReducer";
import {activeBookingsActions} from "booking-creator/reducers/activeBookings/slice";
import {activeLayoutsActions} from "booking-creator/reducers/activeLayouts/slice";
import {activeScheduleActions} from "booking-creator/reducers/activeSchedule/slice";
import {activeSectionsActions} from "booking-creator/reducers/activeSections/slice";
import {bookingOptionsUpsellActions} from "booking-creator/reducers/bookingOptionsUpsell/slice";
import {bookingTimesActions} from "booking-creator/reducers/bookingTimes/slice";
import {communicationActions} from "booking-creator/reducers/communication/slice";
import {customerActions} from "booking-creator/reducers/customer/slice";
import {displayActions as BookingCreatorDisplayActions} from "booking-creator/reducers/display/slice";
import {paymentActions} from "booking-creator/reducers/payment/slice";
import {recurringBookingActions} from "booking-creator/reducers/recurringBooking/slice";
import {scrollPositionActions} from "booking-creator/reducers/scrollPosition/slice";
import {settingActions} from "app/reducers/settings/slice";
import {standbyListActions} from "booking-creator/reducers/standbyList/slice";
import {tablesActions} from "booking-creator/reducers/tables/slice";
import {tagsActions} from "booking-creator/reducers/tags/slice";
import {validationActions} from "booking-creator/reducers/validation/slice";
import {scheduleActions} from "app/reducers/schedule/slice";
import {ScheduleFilterService} from "external-services/schedule-filter-service/scheduleFilter.service";
import {layoutActions} from "app/reducers/layout/slice";
import {sectionActions} from "app/reducers/section/slice";
import {serviceActions} from "app/reducers/service/slice";

const NS = 'venueSlice';

// @todo: populate with real venue data
const initialState: IVenueState = {
  id: 0,
  name: '',
  timeZoneId: '',
  country: '',
  state: '',
  standByList: false,
  standByListEmail: false,
  standByListSMS: false,
  smsEnabled: false,
  currency: '',
  isSwitchVenue: false,
  enableSmsWaitList: false,
  enableBookedByOnDiary: false,
  isDiaryMobileActive: false,
  enableDiaryMobilePlusRestricted: false,
  enableNewFloorPlan: false,
  showNewFloorPlan: false,
  titleSubscription: '',
};

export const resetReducersForApp = (dispatch: AppDispatch) => {

   dispatch(activeBookingsActions.reset());
   dispatch(activeLayoutsActions.reset());
   dispatch(activeScheduleActions.reset());
   dispatch(activeSectionsActions.reset());
   dispatch(bookingOptionsUpsellActions.reset());
   dispatch(bookingTimesActions.reset());
   dispatch(communicationActions.reset());
   dispatch(customerActions.reset());
   dispatch(BookingCreatorDisplayActions.reset());
   dispatch(paymentActions.reset()); // Have to make sure that reset is called after the new booking slider is completed
   dispatch(recurringBookingActions.reset());
   dispatch(scrollPositionActions.setScrollItems([]));
   dispatch(settingActions.reset());
   dispatch(standbyListActions.reset());
   dispatch(tablesActions.reset());
   dispatch(tagsActions.reset());
   dispatch(validationActions.reset());
   dispatch(scheduleActions.reset());
   ScheduleFilterService.clearSchedulesByDayNum();
   dispatch(layoutActions.reset());
   dispatch(sectionActions.reset());
   dispatch(serviceActions.reset());
   dispatch(actions.reset());
  /**
   dispatch(pouchActions.reset());
   */
   console.log('All reducers reset');
}




const venueSlice = createSlice({
  name: 'venue', // used in action types
  initialState,
  reducers: {
    setVenueDetails: (state: IVenueState, action: PayloadAction<IDiaryVenue>) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.timeZoneId = action.payload.timeZoneId;
      state.country = action.payload.country;
      state.state = action.payload.state;
      state.isTakeAwayMode = action.payload.isTakeAwayMode;
      state.standByList = action.payload.standByList;
      state.standByListEmail = action.payload.standByListEmail;
      state.standByListSMS = action.payload.standByListSMS;
      state.smsEnabled = action.payload.smsEnabled;
      state.enableSmsWaitList = action.payload.enableSmsWaitList;
      state.enableBookedByOnDiary = action.payload.enableBookedByOnDiary;
      state.enableDiaryMobilePlusRestricted = false;
      state.isDiaryMobileActive = true;
      state.enableNewFloorPlan = action.payload.enableNewFloorPlan;
      state.showNewFloorPlan = action.payload.showNewFloorPlan;
      state.currency = action.payload.currency;
      state.titleSubscription = action.payload.titleSubscription;
    },
    setIsSwitchVenue: (state: IVenueState, action: PayloadAction<boolean>) => {
      state.isSwitchVenue = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

const timeZoneIdSelector = (state: IVenueState) => state.timeZoneId;
// for react components
export const getVenueTimeZoneId = () => useSelector(timeZoneIdSelector);
// for none react components
export const getVenueTimeZoneIdFromStore = () =>
  (store.getState() as DiaryRootState).venueReducer.timeZoneId;

// Extract the action creators object and the reducer
const { actions, reducer } = venueSlice;
// Extract and export each action creator by name
export { actions as venueActions };
// Export the reducer, either as a default or named export
export default reducer;
